// WorkDay sections that other modules' pages embed (#253): the current-month
// attendance table on the Account home (`hideHeader`). Registered from
// `./index` at bootstrap; the page renders it by id and does not import
// WorkDay. Contract: `src/lib/slots.tsx`. Registrations only.
import { registerSlot } from '@/lib/slots'

registerSlot({
    id: 'work-day.list',
    load: () => import('./components/List'),
})
